const AboutParagraph = ({ children }) => {
  return <p className='mb-14 mx-auto text-center xl:mb-10'>{children}</p>;
};

export default AboutParagraph;
